export default __webpack_public_path__ + "static/media/logo.38302133.png";